import React from "react"
import {dateTimePrint} from '../../common/methods/CommonUtil'
import { useTranslation } from "react-i18next";

function OfferTopData(props) {
  const { t } = useTranslation();
  let datest = new Date(props.startTime);
  
  return (
      <>
      {dateTimePrint(props.language , datest, 'MMDD/')}{' ' + t("offer.start")}
      </>
  )
}

export default OfferTopData
